// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"209":"component---src-templates-dumpsters-kpp-pages-js","684":"cada2cc6","774":"framework"}[chunkId] || chunkId) + "-" + {"209":"5f2018449ffa07ecad58","212":"f6497c09e1b4176f316b","589":"e5755b5cf428fee68086","684":"d2cdbf2a11d3d1a50e39","774":"64fb867057913ead4b67"}[chunkId] + ".js";
};